import { styled } from 'styled-components';

export const Content = styled.article`
  display: flex;
  gap: var(--spacing-small);
  text-align: left;
  width: 100%;
`;
